import React, {Component} from "react";
import './ModifierEtudiant.css'

class ModifierEtudiant extends Component {
    state = {
        id: "",
        etudiants: [{"id":19,"numero_etudiant":"MI-19-2021-00008","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":19095059750,"annee_bac":"2019","branche_bac":"تقني رياضي","moyenne_bac":15.14,"montion_bac":"جيد","cycle":"ماستر","annee_actuelle":"السنة الثانية","specialite_generale":"إعلام آلي","specialite_speciale":"IA","section":"A","groupe":1,"sous_groupe":2,"faculte_origine":null,"classe_origine":null,"universite_origine":null,"createdAt":"2021-11-05T11:29:10.222Z","updatedAt":"2021-11-16T13:44:26.624Z"},{"id":20,"numero_etudiant":"MI-19-2021-00009","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":19095059750,"annee_bac":"2019","branche_bac":"تقني رياضي","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الثالثة","specialite_generale":"إعلام آلي","specialite_speciale":"ISIL","section":"A","groupe":1,"sous_groupe":2,"faculte_origine":null,"classe_origine":null,"universite_origine":null,"createdAt":"2021-11-05T11:29:10.222Z","updatedAt":"2021-11-05T11:29:10.222Z"},{"id":21,"numero_etudiant":"MI-19-2021-00010","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":19095059750,"annee_bac":"2019","branche_bac":"تقني رياضي","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ماستر","annee_actuelle":"السنة الثانية","specialite_generale":"إعلام آلي","specialite_speciale":"IA","section":"A","groupe":1,"sous_groupe":2,"faculte_origine":null,"classe_origine":null,"universite_origine":null,"createdAt":"2021-11-05T11:29:10.222Z","updatedAt":"2021-11-07T20:37:37.406Z"},{"id":35,"numero_etudiant":"MI-18-2021-00035","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":3333,"annee_bac":"2018","branche_bac":"الرياضيات","moyenne_bac":12.22,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"إعلام آلي","specialite_speciale":"SI","section":"A","groupe":1,"sous_groupe":1,"faculte_origine":null,"classe_origine":null,"universite_origine":null,"createdAt":"2021-11-07T11:05:42.098Z","updatedAt":"2021-11-07T20:36:50.222Z"},{"id":49,"numero_etudiant":"MI-21-2021-00049","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":765765,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":18,"montion_bac":"ممتاز","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":null,"section":"A","groupe":1,"sous_groupe":1,"faculte_origine":"علوم وتكنولوجيا","classe_origine":"الإعلام الآلي","universite_origine":"جامعة هواري","createdAt":"2021-11-11T18:26:03.165Z","updatedAt":"2021-11-11T18:26:03.165Z"},{"id":50,"numero_etudiant":"MI-21-2021-00050","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":765765,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":null,"section":"A","groupe":1,"sous_groupe":1,"faculte_origine":"علوم وتكنولوجيا","classe_origine":"الإعلام الآلي","universite_origine":"","createdAt":"2021-11-11T18:26:13.116Z","updatedAt":"2021-11-11T18:26:13.116Z"},{"id":52,"numero_etudiant":"MI-21-2021-00052","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":56656,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":12,"montion_bac":"قريب من الجيد","cycle":"ماستر","annee_actuelle":"السنة الثانية","specialite_generale":"إعلام آلي","specialite_speciale":"IDO","section":"B","groupe":2,"sous_groupe":2,"faculte_origine":"رياضيات وإعلام آلي","classe_origine":"الإعلام الآلي","universite_origine":"جامعة هواري","createdAt":"2021-11-11T18:56:00.125Z","updatedAt":"2021-11-16T19:51:09.424Z"},{"id":53,"numero_etudiant":"MI-21-2021-00053","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":56656,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ماستر","annee_actuelle":"السنة الثانية","specialite_generale":"إعلام آلي","specialite_speciale":"SIGL","section":"B","groupe":2,"sous_groupe":2,"faculte_origine":"علوم وتكنولوجيا","classe_origine":"الرياضيات","universite_origine":"","createdAt":"2021-11-11T18:56:19.959Z","updatedAt":"2021-11-11T18:56:19.959Z"},{"id":54,"numero_etudiant":"MI-21-2021-00054","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":56656,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ماستر","annee_actuelle":"السنة الثانية","specialite_generale":"إعلام آلي","specialite_speciale":"SIGL","section":"B","groupe":2,"sous_groupe":2,"faculte_origine":"علوم وتكنولوجيا","classe_origine":"الرياضيات","universite_origine":"جامعة الجلفة","createdAt":"2021-11-11T18:56:50.823Z","updatedAt":"2021-11-11T18:56:50.823Z"},{"id":55,"numero_etudiant":"MI-21-2021-00055","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":222222,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":15.14,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"F","groupe":1,"sous_groupe":1,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-14T19:16:02.858Z","updatedAt":"2021-11-14T19:21:40.842Z"},{"id":56,"numero_etudiant":"MI-21-2021-00056","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":223223,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":15,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"D","groupe":6,"sous_groupe":1,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-16T09:12:00.612Z","updatedAt":"2021-11-16T09:12:00.612Z"},{"id":57,"numero_etudiant":"MI-21-2021-00057","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":2333,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":18,"montion_bac":"ممتاز","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"D","groupe":6,"sous_groupe":1,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-16T11:29:48.595Z","updatedAt":"2021-11-16T11:29:48.595Z"},{"id":58,"numero_etudiant":"MI-21-2021-00058","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":4567,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":13,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"A","groupe":1,"sous_groupe":1,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-16T12:11:43.776Z","updatedAt":"2021-11-16T12:11:43.776Z"},{"id":59,"numero_etudiant":"MI-21-2021-00059","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":3,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":12,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"A","groupe":1,"sous_groupe":1,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-16T13:46:51.396Z","updatedAt":"2021-11-16T13:46:51.396Z"},{"id":60,"numero_etudiant":"MI-21-2021-00060","prenom_ar":"جلول","nom_ar":"سلامي","prenom_fr":"Djelloul","nom_fr":"SELLAMI","date_naissance":"1989-11-22","lieu_naissance":"المسيلة","pere":"جمال","mere":"جمال","adresse":"المسيلة","email":"sellami.djelloul@gmail.com","numero_bac":222,"annee_bac":"2021","branche_bac":"علوم تجريبية","moyenne_bac":12,"montion_bac":"قريب من الجيد","cycle":"ليسانس","annee_actuelle":"السنة الأولى","specialite_generale":"جذع مشترك رياضيات وإعلام آلي","specialite_speciale":"","section":"A","groupe":1,"sous_groupe":2,"faculte_origine":"","classe_origine":"","universite_origine":"","createdAt":"2021-11-16T13:48:30.079Z","updatedAt":"2021-11-16T13:48:30.079Z"}],
        numero_etudiant: "",
        prenom_ar: "",
        nom_ar: "",
        prenom_fr: "",
        nom_fr: "",
        date_naissance: "",
        lieu_naissance: "",
        pere: "",
        mere: "",
        adresse: "",
        email: "",
        numero_bac: "",
        annee_bac: "",
        branche_bac: "",
        moyenne_bac: "",
        montion_bac: "",
        cycle: "",
        annee_actuelle: "",
        specialite_generale: "",
        specialite_speciale: "",
        section: "",
        groupe: "",
        sous_groupe: ""
    }

    declancherAlert = (message) => {
        let alert = document.getElementsByClassName('alert')[0]
        alert.innerHTML = message
        alert.style.display = "block"
        setTimeout(function(){ alert.style.display = "none"; }, 2000);
    }

    componentDidMount() {
            this.setState({
                id: this.state.etudiants[0].id,
                numero_etudiant: this.state.etudiants[0].numero_etudiant,
                prenom_ar: this.state.etudiants[0].prenom_ar,
                nom_ar: this.state.etudiants[0].nom_ar,
                prenom_fr: this.state.etudiants[0].prenom_fr,
                nom_fr: this.state.etudiants[0].nom_fr,
                date_naissance: this.state.etudiants[0].date_naissance,
                lieu_naissance: this.state.etudiants[0].lieu_naissance,
                pere: this.state.etudiants[0].pere,
                mere: this.state.etudiants[0].mere,
                adresse: this.state.etudiants[0].adresse,
                email: this.state.etudiants[0].email,
                numero_bac: this.state.etudiants[0].numero_bac,
                annee_bac: this.state.etudiants[0].annee_bac,
                branche_bac: this.state.etudiants[0].branche_bac,
                moyenne_bac: this.state.etudiants[0].moyenne_bac,
                montion_bac: this.state.etudiants[0].montion_bac,
                cycle: this.state.etudiants[0].cycle,
                annee_actuelle: this.state.etudiants[0].annee_actuelle,
                specialite_generale: this.state.etudiants[0].specialite_generale,
                specialite_speciale: this.state.etudiants[0].specialite_speciale,
                section: this.state.etudiants[0].section,
                groupe: this.state.etudiants[0].groupe,
                sous_groupe: this.state.etudiants[0].sous_groupe
            })

            document.getElementsByName('nom_ar')[0].value = this.state.etudiants[0].nom_ar
            document.getElementsByName('prenom_ar')[0].value = this.state.etudiants[0].prenom_ar
            document.getElementsByName('nom_fr')[0].value = this.state.etudiants[0].nom_fr
            document.getElementsByName('prenom_fr')[0].value = this.state.etudiants[0].prenom_fr
            document.getElementsByName('date_naissance')[0].value = this.state.etudiants[0].date_naissance
            document.getElementsByName('lieu_naissance')[0].value = this.state.etudiants[0].lieu_naissance
            document.getElementsByName('pere')[0].value = this.state.etudiants[0].pere
            document.getElementsByName('mere')[0].value = this.state.etudiants[0].mere
            document.getElementsByName('adresse')[0].value = this.state.etudiants[0].adresse
            document.getElementsByName('email')[0].value = this.state.etudiants[0].email
            document.getElementsByName('numero_bac')[0].value = this.state.etudiants[0].numero_bac
            document.getElementsByName('annee_bac')[0].value = this.state.etudiants[0].annee_bac
            document.getElementsByName('branche_bac')[0].value = this.state.etudiants[0].branche_bac
            document.getElementsByName('moyenne_bac')[0].value = this.state.etudiants[0].moyenne_bac
            document.getElementsByName('montion_bac')[0].value = this.state.etudiants[0].montion_bac
            document.getElementsByName('cycle')[0].value = this.state.etudiants[0].cycle
            document.getElementsByName('annee_actuelle')[0].value = this.state.etudiants[0].annee_actuelle
            document.getElementsByName('specialite_generale')[0].value = this.state.etudiants[0].specialite_generale
            document.getElementsByName('specialite_speciale')[0].value = this.state.etudiants[0].specialite_speciale
            document.getElementsByName('section')[0].value = this.state.etudiants[0].section
            document.getElementsByName('groupe')[0].value = this.state.etudiants[0].groupe
            document.getElementsByName('sous_groupe')[0].value = this.state.etudiants[0].sous_groupe
    }

    stringContainsNumber(_string) {
        return /\d/.test(_string);
    }

    hideModal = () => {
        document.getElementById('id01').style.display='none'
    }

    showModal = (e) => {
        e.preventDefault()

        let ok = true

        if(this.state.sous_groupe.length === 0) {
            ok = false
            this.declancherAlert("يرجى اختيار المجموعة الجزئية")
        }

        if(this.state.groupe.length === 0) {
            ok = false
            this.declancherAlert("يرجى اختيار الفوج")
        }

        if(this.state.section.length === 0) {
            ok = false
            this.declancherAlert("يرجى اختيار المجموعة")
        }

        if(this.state.specialite_generale.length === 0) {
            ok = false
            this.declancherAlert("يرجى اختيار الشعبة")
        }

        if(this.state.annee_actuelle.length === 0) {
            ok = false
            this.declancherAlert("يرجى اختيار السنة")
        }

        if(this.state.cycle.length === 0) {
            ok = false
            this.declancherAlert("يرجى اختيار الطور")
        }

        if(this.state.montion_bac.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من التقدير")
        }

        if(this.state.moyenne_bac.length === 0 || parseInt(this.state.moyenne_bac) <0 || parseInt(this.state.moyenne_bac) > 20) {
            ok = false
            if(parseInt(this.state.moyenne_bac) <0 || parseInt(this.state.moyenne_bac) > 20)
                this.declancherAlert("معدل البكالوريا يجب أن يكون أكبر من 0 أو أصغير من 20")
            else
                this.declancherAlert("يرجى التحقق من معدل البكالوريا")
        }

        if(this.state.branche_bac.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من شعبة البكالوريا")
        }

        if(this.state.annee_bac.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من دورة البكالوريا")
        }

        if(this.state.numero_bac.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من رقم البكالوريا")
        }

        if(this.state.adresse.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من العنوان")
        }

        if(this.state.mere.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من اسم ولقب الأم")
        }

        if(this.state.pere.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من اسم الأب")
        }

        if(this.state.lieu_naissance.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من مكان الإزدياد")
        }

        if(this.state.date_naissance.length === 0) {
            ok = false
            this.declancherAlert("يرجى التحقق من تاريخ الإزدياد")
        }

        if(this.state.nom_fr.length === 0 || this.stringContainsNumber(this.state.nom_fr)) {
            ok = false
            this.declancherAlert("يرجى التحقق من اللقب بالفرنسية")
        }

        if(this.state.prenom_fr.length === 0 || this.stringContainsNumber(this.state.prenom_fr)) {
            ok = false
            this.declancherAlert("يرجى التحقق من الإسم بالفرنسية")
        }

        if(this.state.nom_ar.length === 0 || this.stringContainsNumber(this.state.nom_ar)) {
            ok = false
            this.declancherAlert("يرجى التحقق من اللقب بالعربية")
        }

        if(this.state.prenom_ar.length === 0 || this.stringContainsNumber(this.state.prenom_ar)) {
            ok = false
            this.declancherAlert("يرجى التحقق من الإسم بالعربية")
        }

        if(ok) {
            let modal = document.getElementById('id01');
            modal.style.display = "block";
            ok = false
        }

    }

    enregistrer = (e) => {
        e.preventDefault()
        this.hideModal()
        let tt = document.getElementsByClassName('alert-success')[0]
        tt.innerHTML  = "تم تعديل معلومات الطالب بنجاح"
        tt.style.display  = "block"
        setTimeout(function(){ tt.style.display = "none"; }, 2000);
    }

    prenom_ar_change = (e) => { this.setState({ prenom_ar: e.target.value }) }
    nom_ar_change = (e) => { this.setState({ nom_ar: e.target.value }) }
    prenom_fr_change = (e) => {
        let prenom = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)
        this.setState({ prenom_fr: prenom })
        e.target.value = prenom
    }
    nom_fr_change = (e) => {
        this.setState({ nom_fr: e.target.value.toUpperCase() })
        e.target.value = e.target.value.toUpperCase()
    }
    date_naissance_change = (e) => { this.setState({ date_naissance: e.target.value }) }
    lieu_naissance_change = (e) => { this.setState({ lieu_naissance: e.target.value }) }
    pere_change = (e) => {
        let pere = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)
        this.setState({ pere: pere })
        e.target.value = pere
    }
    mere_change = (e) => {
        let mere = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)
        this.setState({ mere: mere })
        e.target.value = mere
    }
    adresse_change = (e) => { this.setState({ adresse: e.target.value }) }
    email_change = (e) => { this.setState({ email: e.target.value }) }
    numero_bac_change = (e) => { this.setState({ numero_bac: e.target.value }) }
    annee_bac_change = (e) => { this.setState({ annee_bac: e.target.value }) }
    branche_bac_change = (e) => { this.setState({ branche_bac: e.target.value }) }
    moyenne_bac_change = (e) => {
        this.setState({ moyenne_bac: e.target.value })
        if(parseFloat(e.target.value) >= 0 && parseFloat(e.target.value) < 12) {
            document.getElementsByName('montion_bac')[0].value = "مقبول"
            this.setState({ montion_bac: "مقبول" })
        }
        if(parseFloat(e.target.value) >= 12 && parseFloat(e.target.value) < 14) {
            document.getElementsByName('montion_bac')[0].value = "قريب من الجيد"
            this.setState({ montion_bac: "قريب من الجيد" })
        }
        if(parseFloat(e.target.value) >= 14 && parseFloat(e.target.value) < 16) {
            document.getElementsByName('montion_bac')[0].value = "جيد"
            this.setState({ montion_bac: "جيد" })
        }
        if(parseFloat(e.target.value) >= 16 && parseFloat(e.target.value) < 18) {
            document.getElementsByName('montion_bac')[0].value = "جيد جدا"
            this.setState({ montion_bac: "جيد جدا" })
        }
        if(parseFloat(e.target.value) >= 18 && parseFloat(e.target.value) <= 20) {
            document.getElementsByName('montion_bac')[0].value = "ممتاز"
            this.setState({ montion_bac: "ممتاز" })
        }
        if(parseFloat(e.target.value) < 0 || parseFloat(e.target.value) > 20) {
            document.getElementsByName('montion_bac')[0].value = "اختر التقدير"
            this.setState({ montion_bac: "" })
        }
    }
    montion_bac_change = (e) => { this.setState({ montion_bac: e.target.value }) }
    cycle_change = (e) => { this.setState({ cycle: e.target.value }) }
    annee_actuelle_change = (e) => { this.setState({ annee_actuelle: e.target.value }) }
    specialite_generale_change = (e) => { this.setState({ specialite_generale: e.target.value }) }
    specialite_special_change = (e) => { this.setState({ specialite_special: e.target.value }) }
    section_change = (e) => { this.setState({ section: e.target.value }) }
    groupe_change = (e) => { this.setState({ groupe: e.target.value }) }
    sous_groupe_change = (e) => { this.setState({ sous_groupe: e.target.value }) }

    render() {
        return(
            <div className="container-modifier-etudiant">
                <h2>تعديل ملف الطالب</h2>
                <div className="sous-container-modifier-etudiant">
                    <form className="form-n">
                        <fieldset>
                            <legend>المعلومات الشخصية</legend>
                            <div className="row">
                                <div className="col3">
                                    <label>الإسم باللغة العربية<span className="required">*</span></label>
                                    <input type="text" name="prenom_ar" onChange={this.prenom_ar_change} className="field-divided" placeholder="الإسم" />
                                </div>
                                <div className="col3">
                                    <label>اللقب باللغة العربية<span className="required">*</span></label>
                                    <input type="text" name="nom_ar" onChange={this.nom_ar_change} className="field-divided" placeholder="اللقب" />
                                </div>
                                <div className="col3">
                                    <label>الإسم باللغة الفرنسية<span className="required">*</span></label>
                                    <input dir="ltr" type="text" name="prenom_fr" onChange={this.prenom_fr_change} className="field-divided" placeholder="Le prénom" />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col3">
                                    <label>اللقب باللغة الفرنسية<span className="required">*</span></label>
                                    <input dir="ltr" type="text" name="nom_fr" onChange={this.nom_fr_change} className="field-divided" placeholder="Le nom de famille" />
                                </div>
                                <div className="col3">
                                    <label>تاريخ الإزدياد<span className="required">*</span></label>
                                    <input type="date" name="date_naissance" onChange={this.date_naissance_change} className="field-divided"/>
                                </div>
                                <div className="col3">
                                    <label>مكان الإزدياد<span className="required">*</span></label>
                                    <input type="text" name="lieu_naissance" onChange={this.lieu_naissance_change} className="field-divided" placeholder="مكان الإزدياد" />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col3">
                                    <label>إسم الأب<span className="required">*</span></label>
                                    <input type="text" name="pere" onChange={this.pere_change} className="field-divided" placeholder="إسم الأب" />
                                </div>
                                <div className="col3">
                                    <label>إسم ولقب الأم<span className="required">*</span></label>
                                    <input type="text" name="mere" onChange={this.mere_change} className="field-divided" placeholder="إسم ولقب الأم" />
                                </div>
                                <div className="col3">
                                    <label>العنوان<span className="required">*</span></label>
                                    <input type="text" name="adresse" onChange={this.adresse_change} className="field-divided" placeholder="العنوان" />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col3">
                                    <label>الإيميل</label>
                                    <input type="email" name="email" onChange={this.email_change} className="field-divided" placeholder="الإيميل" />
                                </div>
                                <div className="col3"></div>
                                <div className="col3"></div>
                            </div>
                        </fieldset>
                        <fieldset>
                            <legend>معلومات شهادة البكالوريا</legend>
                            <div className="row">
                                <div className="col3">
                                    <label>رقم شهادة البكالوريا<span className="required">*</span></label>
                                    <input type="number" name="numero_bac" onChange={this.numero_bac_change} className="field-divided" placeholder="رقم الشهادة" />
                                </div>
                                <div className="col3">
                                    <label>الدورة<span className="required">*</span></label>
                                    <select name="annee_bac" onChange={this.annee_bac_change} className="field-divided">
                                        <option value="">اختر الدورة</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                    </select>
                                </div>
                                <div className="col3">
                                    <label>الشعبة<span className="required">*</span></label>
                                    <select name="branche_bac" onChange={this.branche_bac_change} className="field-divided">
                                        <option value="">اختر الشعبة</option>
                                        <option value="علوم تجريبية">علوم تجريبية</option>
                                        <option value="الرياضيات">رياضيات</option>
                                        <option value="تقني رياضي">تقني رياضي</option>
                                        <option value="تسيير واقتصاد">تسيير واقتصاد</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col3">
                                    <label>المعدل<span className="required">*</span></label>
                                    <input type="number" name="moyenne_bac" onChange={this.moyenne_bac_change} className="field-divided" placeholder="المعدل" />
                                </div>
                                <div className="col3">
                                    <label>التقدير<span className="required">*</span></label>
                                    <select name="montion_bac" onChange={this.montion_bac_change} className="field-divided">
                                        <option value="">اختر التقدير</option>
                                        <option value="مقبول">مقبول</option>
                                        <option value="قريب من الجيد">قريب من الجيد</option>
                                        <option value="جيد">جيد</option>
                                        <option value="جيد جدا">جيد جدا</option>
                                        <option value="ممتاز">ممتاز</option>
                                    </select>
                                </div>
                                <div className="col3"></div>
                            </div>
                        </fieldset>
                        <fieldset>
                            <legend>معلومات التمدرس</legend>
                            <div className="row">
                                <div className="col3">
                                    <label>الطور<span className="required">*</span></label>
                                    <select name="cycle" onChange={this.cycle_change} className="field-divided">
                                        <option value="ليسانس">ليسانس</option>
                                        <option value="ماستر">ماستر</option>
                                        <option value="دكتورا">دكتورا</option>
                                    </select>
                                </div>
                                <div className="col3">
                                    <label>السنة الحالية<span className="required">*</span></label>
                                    <select name="annee_actuelle" onChange={this.annee_actuelle_change} className="field-divided">
                                        <option value="السنة الأولى">السنة الأولى</option>
                                        <option value="السنة الثانية">السنة الثانية</option>
                                        <option value="السنة الثالثة">السنة الثالثة</option>
                                    </select>
                                </div>
                                <div className="col3">
                                    <label>الشعبة<span className="required">*</span></label>
                                    <select name="specialite_generale" onChange={this.specialite_generale_change} className="field-divided">
                                        <option value="جذع مشترك رياضيات وإعلام آلي">جذع مشترك رياضيات وإعلام آلي</option>
                                        <option value="إعلام آلي">إعلام آلي</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col3">
                                    <label>الإختصاص<span className="required">*</span></label>
                                    <select name="specialite_speciale" onChange={this.specialite_speciale_change} className="field-divided">
                                        <option value="إعلام آلي">إعلام آلي</option>
                                        <option value="SI">SI</option>
                                        <option value="ISIL">ISIL</option>
                                        <option value="SIGL">SIGL</option>
                                        <option value="IDO">IDO</option>
                                        <option value="RTIC">RTIC</option>
                                        <option value="IA">IA</option>
                                    </select>
                                </div>
                                <div className="col3">

                                </div>
                                <div className="col3">

                                </div>
                            </div>

                            <div className="row">
                                <div className="col3">
                                    <label>المجموعة<span className="required">*</span></label>
                                    <select name="section" onChange={this.section_change} className="field-divided">
                                        <option value="">اختر المجموعة</option>
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                        <option value="D">D</option>
                                        <option value="E">E</option>
                                        <option value="F">F</option>
                                    </select>
                                </div>
                                <div className="col3">
                                    <label>الفوج<span className="required">*</span></label>
                                    <select name="groupe" onChange={this.groupe_change} className="field-divided">
                                        <option value="">الفوج</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                    </select>
                                </div>
                                <div className="col3">
                                    <label>الفوج الفرعي<span className="required">*</span></label>
                                    <select name="sous_groupe" onChange={this.sous_groupe_change} className="field-divided">
                                        <option value="">الفوج الفرعي</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                    </select>
                                </div>
                            </div>
                        </fieldset>

                        <div className="row">

                            <input onClick={this.showModal} type="submit" value="تعديل الملف" />

                        </div>
                        <div className="alert-section">
                            <div className="alert" style={{display: "none", position: "absolute", alignItems: "center", bottom: 70, minWidth: "300px"}}>

                            </div>
                            <div className="alert-success" style={{display: "none", position: "absolute", bottom: 70, minWidth: "300px"}}>

                            </div>
                        </div>
                    </form>
                    <div id="id01" className="modal1">
                        <div className="container modal-content">
                            <h2>هل تريد حفظ التعديلات ؟</h2>

                            <div className="clearfix">
                                <button type="button" onClick={this.hideModal}
                                        className="cancelbtn">لا
                                </button>
                                <button type="button" onClick={this.enregistrer}
                                        className="confirmbtn">نعم
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}

export default ModifierEtudiant